import { VariantProps } from 'class-variance-authority'
import CustomLink from '../elements/CustomLink'
import { BardLinkButton as BardLinkButtonType } from '@/src/@types/statamic'
import Button, { buttonStyle } from '@/src/components/core/Button'

export default function BardLinkButton({
  link_link,
  link_text,
  color,
}: BardLinkButtonType) {
  let buttonVersion: VariantProps<typeof buttonStyle>['version'] = 'purple'
  switch (color.value) {
    case 'whatsapp':
      buttonVersion = 'green'
      break
  }

  return (
    <div>
      <CustomLink href={link_link.url} passHref>
        <Button as="a" version={buttonVersion}>
          {link_text}
        </Button>
      </CustomLink>
    </div>
  )
}
